import { Component, input } from "@angular/core";
import { APIService } from "app/shared/api.service";
import { EquipmentSchedule } from "app/shared/schedule.service";

@Component({
  selector: "app-site-schedule",
  standalone: false,
  templateUrl: "./site-schedule.component.html",
  styleUrl: "./site-schedule.component.css",
})
export class SiteScheduleComponent {

  siteSchedule = input.required<EquipmentSchedule>();

  constructor(private apiService: APIService) { }

  uploadSchedule() {
    console.log('TODO');
    this.apiService.toastWarn('Not implemented.');
  }

  saveSchedule() {
    console.log('TODO');
    this.apiService.toastWarn('Not implemented.');
  }

  getSchedule() {
    console.log('TODO');
    this.apiService.toastWarn('Not implemented.');
  }
}
